import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';
import { provider_ids_sorted_v1, provider_ids_sorted_v2 } from './data';
import { BuyboxRegularOffer } from '@/components/buybox-new/types';

// ?preferred_variant=BUYBOX_SORTNG_EXP:control
// ?preferred_variant=BUYBOX_SORTNG_EXP:variant_1
// ?preferred_variant=BUYBOX_SORTNG_EXP:variant_2

// ?remove_preferred_experiment=BUYBOX_SORTNG_EXP

export const BuyBoxSortingExpName = 'BUYBOX_SORTNG_EXP' as const;

export type BuyBoxSortingExpVariants = ToVariants<typeof BuyBoxSortingExpVariants>;

export const BuyBoxSortingExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
} as const;

export default generate(BuyBoxSortingExpName, BuyBoxSortingExpVariants);

export function sortProviders(providers: BuyboxRegularOffer[], variant: BuyBoxSortingExpVariants) {
	const provider_ids_sorted =
		variant === BuyBoxSortingExpVariants.VARIANT_1 ? provider_ids_sorted_v1 : provider_ids_sorted_v2;

	return providers.toSorted((a, b) => {
		const indexA = provider_ids_sorted.indexOf(a.package.packageId);
		const indexB = provider_ids_sorted.indexOf(b.package.packageId);

		if (indexA === -1 && indexB === -1) return 0; // both not found
		if (indexA === -1) return 1; // a not found, b found
		if (indexB === -1) return -1; // a found, b not found

		return indexA - indexB;
	});
}
